import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ChevronDown, ChevronUp } from 'lucide-react';

const faqData = [
  {
    question: "¿Qué es Alphatica?",
    answer: "Alphatica es una tienda especializada en fragancias de inspiración. Nuestros perfumes están diseñados para evocar perfiles olfativos similares a fragancias populares del mercado, pero son comercializados bajo nuestra propia marca."
  },
  {
    question: "¿Los perfumes son originales?",
    answer: "Las fragancias de Alphatica son perfumes de inspiración. Esto significa que están inspiradas en aromas conocidos, pero no son productos originales de las marcas que sirven como referencia."
  },
  {
    question: "¿Los perfumes son imitaciones o réplicas?",
    answer: "No. Las fragancias de Alphatica son interpretaciones aromáticas desarrolladas de manera independiente. No utilizamos nombres, logotipos, empaques ni elementos de identidad de otras marcas."
  },
  {
    question: "¿Cuánto dura un perfume?",
    answer: "La duración de una fragancia depende de varios factores, como el tipo de piel, la temperatura ambiente y la cantidad aplicada. En condiciones normales, las fragancias pueden tener una duración aproximada de 6 a 8 horas."
  },
  {
    question: "¿Los perfumes son para hombre o mujer?",
    answer: "Contamos con fragancias masculinas, femeninas y unisex. Puedes filtrar nuestro catálogo por género para encontrar la fragancia perfecta para ti."
  },
  {
    question: "¿Cuánto tarda el envío?",
    answer: "Los pedidos se procesan generalmente dentro de 1 a 2 días hábiles después de confirmado el pago. El tiempo de entrega estimado dentro de México es de 2 a 5 días hábiles, dependiendo de la ubicación del cliente."
  },
  {
    question: "¿Puedo devolver un perfume si no me gustó?",
    answer: "Por razones de higiene y seguridad, los perfumes no pueden devolverse una vez abiertos. Solo se aceptan devoluciones en caso de productos dañados o defectuosos."
  },
  {
    question: "¿Cómo puedo contactar a Alphatica?",
    answer: "Puedes comunicarte con nosotros mediante correo electrónico, formulario de contacto en el sitio web o WhatsApp. Visita nuestra página de contacto para más información."
  }
];

const FAQItem = ({ question, answer, isOpen, onToggle }) => {
  return (
    <div className="border-b border-brand-cobalt/20">
      <button
        onClick={onToggle}
        className="w-full py-5 flex items-center justify-between text-left text-brand-black hover:text-brand-cobalt transition-colors"
      >
        <span className="font-medium text-sm md:text-base pr-4">{question}</span>
        {isOpen ? (
          <ChevronUp size={20} className="flex-shrink-0 text-brand-cobalt" />
        ) : (
          <ChevronDown size={20} className="flex-shrink-0 text-brand-black/50" />
        )}
      </button>
      {isOpen && (
        <div className="pb-5 pr-8">
          <p className="text-brand-black/70 text-sm md:text-base leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="pb-16 bg-brand-bone min-h-screen" data-testid="faq-page">
      {/* Hero */}
      <section className="bg-brand-black/[0.03] py-12 md:py-20 border-b border-brand-cobalt/10">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm text-brand-cobalt hover:text-brand-cobalt/80 mb-6"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight mb-4 text-brand-black">
            Preguntas Frecuentes
          </h1>
          <p className="text-brand-black/60 text-lg">
            Resolvemos tus dudas sobre Alphatica
          </p>
        </div>
      </section>

      {/* FAQ List */}
      <section className="py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-4">
          <div className="divide-y-0">
            {faqData.map((item, index) => (
              <FAQItem
                key={index}
                question={item.question}
                answer={item.answer}
                isOpen={openIndex === index}
                onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
              />
            ))}
          </div>

          {/* Contact CTA */}
          <div className="mt-12 brand-card hybrid-glow p-6 rounded-lg text-center border border-brand-cobalt/30">
            <h3 className="font-display text-xl mb-2 text-brand-black">¿No encontraste tu respuesta?</h3>
            <p className="text-brand-black/60 mb-4">Estamos aquí para ayudarte</p>
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-2 brand-btn rounded"
            >
              Contáctanos
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
